export default {
  spinner: {
    margin: 'auto',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0
  },
  requestError: {
    backgroundColor: 'red',
    color: '#ffffff',
    marginBottom: 20,
    marginLeft: 20,
    marginRight: 20
  },
  controls: {
    display: 'flex',
    justifyContent: 'center',
    margin: "30px 0 50px",
  },
  controlsCentered: {
    textAlign: 'center',
    margin: "10px 0 20px",
  },
  finalMessageContainer: {
    textAlign: 'center'
  },
  envelope: {
    width: 60,
    height: 60,
  },
  bmr: {
    marginRight: 20,
  },
  dialogContent: {
    minWidth: 300
  },
};